import React, {Fragment, Component} from 'react';
import {toTitleCase} from 'common/utils';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {FemaGoModal} from 'app-ui-componentlibrary';
import REST from 'go/requests/rest';
import _ from 'lodash';
import {createRolePermissionsBox} from 'go/components/organization/team/utils';
import {Grid, Loader, Header, Segment, Icon, Popup} from 'semantic-ui-react';
import {AOR_SAR_ROLES} from 'go/components/organization/team/constants';
import {ROLE_MAP, ENTITY_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import {isFemaUser} from 'common/utils';

export class UserOrganizationRolesList extends Component {
  // Onclick - Show Programs
  showProgramModal = () => {
    const dunsToUEIToggle = this.props.toggles.includes('dunsToUEI');
    return (
      <FemaGoModal
        title="Assigned roles and programs"
        size="small"
        open={this.state.openModal}
        buttonText="Ok"
        confirmAction={() => this.setState({openModal: false})}
        cancelAction={() => this.setState({openModal: false})}
      >
        {!this.state.loading ? (
          <React.Fragment>
            <Segment>
              <h3>
                {this.state.modalRole} ,{' '}
                {this.state.orgProgramsMap.get(this.state.modalOrg) !== undefined &&
                this.state.programNum ===
                  this.state.orgProgramsMap.get(this.state.modalOrg).length
                  ? 'All'
                  : this.state.programNum}{' '}
                programs
              </h3>
              <h4>
                {this.state.modalOrg}{' '}
                {dunsToUEIToggle ? ' | UEI-EFT: ' + this.state.modalUEI : ''} | DUNS #{' '}
                {this.state.modalDuns}
              </h4>
            </Segment>
            {this.renderModalPrograms(this.state.modalPrograms)}
          </React.Fragment>
        ) : (
          <Loader active>Loading...</Loader>
        )}
      </FemaGoModal>
    );
  };

  renderModalPrograms(modalGroupedPrograms) {
    return Object.keys(modalGroupedPrograms).map((key) => (
      <Fragment>
        <h5>{key}</h5>
        {_.map(_.sortBy(modalGroupedPrograms[key], 'programName'), function (
          programArray
        ) {
          return <li>{programArray.programName}</li>;
        })}
      </Fragment>
    ));
  }

  // getOrganizations
  getRoles = () => {
    this.setState({loading: true});
    return REST.user
      .getRoles(this.props.jwt)
      .then((response) => {
        if (response.ok) {
          // todo update to use REST.handler.handleResponse
          return response.json();
        } else {
          this.setState({error: true, loading: false});
        }
      })
      .then((res) => {
        if (res) {
          this.setState({
            data: res,
          });
          this.buildModalData();
        }
      });
  };

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      processedRoles: [],
      forRenderRoles: [],
      loading: true,
      openModal: false,
      error: false,
      modalRole: '',
      modalOrg: '',
      modalPrograms: [],
      programNum: 0,
      modalUEI: '',
      modalDuns: '',
      orgUEIMap: new Map(),
      orgDunsMap: new Map(),
      orgProgramsMap: new Map(),
      programsMap: new Map(),
      showRolesModalVisible: false, // used for displaying Roles & Permissions modal/popup
    };
  }

  componentDidMount() {
    this.getRoles(); // rest call
  }

  // REST data reformated and sorted to the display needs
  extractRoles() {
    let sortedRoles = [];
    this.state.data.forEach((userEntity) => {
      if (!_.isEmpty(userEntity.entity)) {
        let [orgId, progId] = userEntity.entity.entityId.split('_');

        if (userEntity.entity.entityTypeId === 1) {
          this.fetchOrgPrograms(this.props.jwt, orgId, userEntity.entity.displayName);
        }
        return userEntity.roles.forEach((role) => {
          sortedRoles.push({
            id: userEntity.entity.entityId + '-' + role.roleId,
            org: userEntity.entity.displayName,
            orgId: orgId,
            uei: userEntity.entity.uei,
            eft: userEntity.entity.eft,
            duns: userEntity.entity.duns,
            dunsPlus4: userEntity.entity.dunsPlus4,
            role: role.description,
            roleId: role.roleId,
            programId: progId,
            entityTypeId: userEntity.entity.entityTypeId,
          });

          //check if there is more than AOR is there for same org with entity 1 and may be 5 and other.Remove AOR with
          // other than entityType 1 as it takes precedence
          let hasOrgAOR = _.find(sortedRoles, {
            orgId: orgId,
            roleId: parseInt(ROLE_MAP.ORGAOR.code),
            entityTypeId: parseInt(parseInt(ENTITY_MAP.ORGANIZATION.code)),
          });
          if (hasOrgAOR) {
            _.remove(sortedRoles, {
              orgId: orgId,
              roleId: parseInt(ROLE_MAP.ORGAOR.code),
              entityTypeId: parseInt(ENTITY_MAP.PROGRAM_ORGANIZATION.code),
            });
          }
        });
      }
    });

    return _.sortBy(sortedRoles, ['org', 'role']);
  }

  toggleProgramsModal = async (org, role, programArr, e) => {
    this.setState({
      loading: true,
      modalRole: role,
      modalOrg: org,
      programNum: programArr.length,
      modalUEI: this.state.orgUEIMap[org],
      modalDuns: this.state.orgDunsMap[org],
      openModal: true,
    });

    let programs = await this.fetchPrograms(this.props.jwt, programArr);
    programs = _.groupBy(programs, 'programCategoryName');
    this.setState({
      modalPrograms: programs,
      loading: false,
    });
  };

  // GET program details for given program ids
  fetchPrograms = async (token, params) => {
    return REST.program
      .getProgramDetails(token, params)
      .then(REST.handler.handleResponse)
      .catch((err) => {
        this.setState({error: true});
      });
  };

  // GET programs for a given org id
  fetchOrgPrograms = async (token, orgId, orgName) => {
    return REST.organizationRelationship
      .getAllUnrestrictedOrganizationProgramsByOrgId(token, orgId)
      .then(REST.handler.handleResponse)
      .then((res) => {
        const programs = res.organizationPrograms;
        let ids = _.map(programs, (program) => {
          return program.programId;
        });

        let orgPgmMap = this.state.orgProgramsMap;
        let pgmArr = _.uniq(ids);
        orgPgmMap.set(orgName, pgmArr);
        this.setState({orgProgramsMap: orgPgmMap});
      });
  };

  // Method to provide whether to display no of programs, or single program detail or all programs (TODO)
  getProgramsDisplay = (pgmIds, orgName) => {
    let numPrograms = 0;

    if (pgmIds !== undefined) {
      if (pgmIds[0] !== undefined) {
        numPrograms = pgmIds.length;
        if (pgmIds.length === 1) {
          return this.state.programsMap.get(parseInt(pgmIds));
        } else {
          if (
            this.state.orgProgramsMap.get(orgName) !== undefined &&
            this.state.orgProgramsMap.get(orgName).length === numPrograms
          ) {
            // return this.state.orgProgramsMap.get(orgName).length + ' programs';
            return 'All programs';
          } else {
            return numPrograms + ' programs';
          }
        }
      }
    }
    return '';
  };

  // builds a map of program desc from the program ids
  buildProgramData = async () => {
    let progMap = new Map();
    let progIds = _.chain(this.state.processedRoles)
      .groupBy('programId')
      .mapValues()
      .keys()
      .value();

    progIds = progIds.filter(function (element) {
      return element !== 'undefined';
    });

    let progInfo = await this.fetchPrograms(this.props.jwt, progIds);

    let prgMap = new Map();
    _.map(progInfo, (progDetail) => {
      prgMap.set(progDetail.programId, progDetail.programDescription);
    });
    this.setState({
      programsMap: prgMap,
    });
  };

  // builds all the duns and data for render roles
  buildDunsUEIMap = () => {
    let orgDunsMap = new Map();
    let orgUEIMap = new Map();
    this.state.forRenderRoles = _(this.state.processedRoles)
      .groupBy('org')
      .transform(function (result, items, key) {
        result[key] = _(items)
          .groupBy('role')
          .transform(function (roleResult, roleItems, rolekey) {
            const eft = _.trim(_.get(roleItems, [0, 'eft']));
            const ueiPlusEft =
              _.get(roleItems, [0, 'uei']) + (!_.isEmpty(eft) ? '-' + eft : '');
            orgUEIMap[key] = _.get(roleItems, [0, 'uei']) ? ueiPlusEft : '';

            const dunsPlus4 = _.get(roleItems, [0, 'dunsPlus4']) || '';
            orgDunsMap[key] = _.get(roleItems, [0, 'duns'], '') + dunsPlus4;
            roleResult[rolekey] = _.map(roleItems, 'programId');
          });
      })
      .value();
    this.setState({orgDunsMap: orgDunsMap});
    this.setState({orgUEIMap: orgUEIMap});
  };

  // main data modal builder method, does post REST data transformation to display model
  buildModalData = async () => {
    if (!_.isEmpty(this.state.data)) {
      this.state.processedRoles = this.extractRoles();
      this.buildProgramData();
      this.buildDunsUEIMap();
    }
    this.setState({loading: false});
  };

  // to check if it has more than 1 program
  hasMorePrograms = (roles) => {
    return (roles && roles.length > 1) || (roles && roles[0] === undefined)
      ? true
      : false;
  };

  // row level rendering
  renderRoles() {
    const dunsToUEIToggle = this.props.toggles.includes('dunsToUEI');
    const items = [];
    _.map(this.state.forRenderRoles, (roleRow, key) => {
      let roleObj = roleRow.value();

      items.push(
        <FemaGoTable.Row key={key} stackable padded="false">
          <FemaGoTable.TextCell width={6} padded={false}>
            <b>{key !== 'undefined' ? key : ''} </b>
            {key !== 'undefined' && dunsToUEIToggle ? <br /> : ''}
            <strong>{key !== 'undefined' && dunsToUEIToggle ? 'UEI-EFT: ' : ''}</strong>
            {key !== 'undefined' && dunsToUEIToggle ? this.state.orgUEIMap[key] : ''}
            <br />
            <strong>{key !== 'undefined' ? 'DUNS #' : ''}</strong>
            {key !== 'undefined' ? this.state.orgDunsMap[key] : ''}
          </FemaGoTable.TextCell>
          <FemaGoTable.TextCell colSpan={2} width={12}>
            {this.renderRoleAndProgram(roleObj, key)}
          </FemaGoTable.TextCell>
        </FemaGoTable.Row>
      );
    });

    return <>{items}</>;
  }

  renderFemaRoles() {
    const items = [];
    _.map(this.state.forRenderRoles, (roleRow, key) => {
      let roleObj = roleRow.value();
      const titleNames = Object.keys(roleObj);
      const titleElements = _.map(titleNames, (title) => <div key={title}>{title}</div>);
      items.push(
        <FemaGoTable.Row key={key} stackable padded="false">
          <FemaGoTable.TextCell width={6} padded={false}>
            <b>{key}</b>
          </FemaGoTable.TextCell>
          <FemaGoTable.TextCell width={6}>{titleElements}</FemaGoTable.TextCell>
        </FemaGoTable.Row>
      );
    });

    return <>{items}</>;
  }

  //arguments are pgmIds and role()
  renderRoleAndProgram = (pgmIdArr, role) => {
    let items1 = [];
    _.forEach(pgmIdArr, async (pgmIds, key) => {
      let tempPgmIds = [];
      if (pgmIds[0] === undefined)
        tempPgmIds = _.clone(this.state.orgProgramsMap.get(role));
      else tempPgmIds = pgmIds;
      if (tempPgmIds) {
        tempPgmIds = tempPgmIds.filter(function (element) {
          return element !== undefined;
        });
      }
      items1.push(
        <FemaGoTable
          type="static"
          className="noBorderTable"
          key={key + '_rowtable_' + role}
          withForm={false}
        >
          <FemaGoTable.Body>
            <FemaGoTable.Row key={key + '_' + role} style="width:100%" width={12}>
              <FemaGoTable.TextCell padded={false} width={8}>
                {key}
              </FemaGoTable.TextCell>
              <FemaGoTable.TextCell width={5}>
                {this.hasMorePrograms(tempPgmIds) && (
                  <a
                    href="#"
                    onClick={(e) => this.toggleProgramsModal(role, key, tempPgmIds, e)}
                  >
                    {this.getProgramsDisplay(tempPgmIds, role)}
                  </a>
                )}
                {!this.hasMorePrograms(tempPgmIds) &&
                  this.getProgramsDisplay(tempPgmIds, key)}
              </FemaGoTable.TextCell>
            </FemaGoTable.Row>
          </FemaGoTable.Body>
        </FemaGoTable>
      );
    });
    return <>{items1}</>;
  };

  // toggle action for role and programs popup modal
  toggleModal = (action) => {
    if (action === 'showRoles') {
      this.setState({
        showRolesModalVisible: !this.state.showRolesModalVisible,
      });
    }
  };

  // component rendering
  render() {
    let header = 'Your roles';
    if (!isFemaUser(this.props.permissions)) {
      header = 'Your organizations, roles & programs';
    } else {
      header = 'Your roles';
    }

    return (
      <Segment>
        <React.Fragment>
          <React.Fragment>
            <FemaGoModal
              title=""
              size="medium"
              open={this.state.showRolesModalVisible}
              confirmButton="hidden"
              cancelAction={() => this.toggleModal('showRoles')}
            >
              {createRolePermissionsBox(AOR_SAR_ROLES, false)}
            </FemaGoModal>

            <Grid verticalAlign="bottom">
              <Grid.Row>
                <Grid.Column width={10}>
                  <Header as="h3">{header}</Header>
                </Grid.Column>
                {!isFemaUser(this.props.permissions) && (
                  <Grid.Column width={6} textAlign="right">
                    <a
                      data-content="Roles and Perms"
                      color="blue"
                      className="rolesAndPermissions"
                      style={{fontSize: '12px'}}
                      onClick={() => this.toggleModal('showRoles')}
                      href="javascript:void(0);"
                    >
                      <Popup
                        hideOnScroll
                        position="top right"
                        wide="very"
                        content={createRolePermissionsBox(AOR_SAR_ROLES, true)}
                        trigger={
                          <div>
                            <Icon
                              name="info circle"
                              color="blue"
                              label="Roles & permissions"
                              title="Roles & permissions"
                            />
                            <strong label="Roles & permissions">
                              {'Roles & permissions'}
                            </strong>
                          </div>
                        }
                      />
                    </a>
                  </Grid.Column>
                )}
              </Grid.Row>
            </Grid>
          </React.Fragment>
          {!this.state.loading ? (
            <React.Fragment>
              <FemaGoTable type="static">
                {!isFemaUser(this.props.permissions) && (
                  <FemaGoTable.Header>
                    <FemaGoTable.Row>
                      <FemaGoTable.HeaderCell width={6}>
                        Organization
                      </FemaGoTable.HeaderCell>
                      <FemaGoTable.HeaderCell width={6}>Roles</FemaGoTable.HeaderCell>
                      <FemaGoTable.HeaderCell width={6}>Programs</FemaGoTable.HeaderCell>
                    </FemaGoTable.Row>
                  </FemaGoTable.Header>
                )}
                {!isFemaUser(this.props.permissions) && (
                  <FemaGoTable.Body>{this.renderRoles()}</FemaGoTable.Body>
                )}
                {isFemaUser(this.props.permissions) && (
                  <FemaGoTable.Body>{this.renderFemaRoles()}</FemaGoTable.Body>
                )}
              </FemaGoTable>
              {this.showProgramModal()}
            </React.Fragment>
          ) : (
            <Loader active>Loading...</Loader>
          )}
        </React.Fragment>
      </Segment>
    );
  }
}

export default UserOrganizationRolesList;
